'use strict';

import angular from 'angular';
import AddController from './add.controller';

export default angular.module('updateServerApp.appconfgroups.add', [])
  .controller('AppConfGroupsAddController', AddController)
  .name;



// WEBPACK FOOTER //
// ./client/app/appconfgroups/add/index.js